<template>
	<div
		class="form-group"
		v-if="(singleBudget.status == 'Expired' && showExpired) || (singleBudget.status != 'Expired' && !showExpired)"
	>
		<div class="row" style="margin:0px;margin-top:5px" v-if="renderComponent">
			<div class="col-md-2 form-group" style="padding:3px">
				<label for="newBudget">New Budget</label>
				<input
					type="text"
					v-bind:disabled="hide"
					v-model="singleBudget.budget"
					v-on:keydown="validKey"
					v-on:click="hideEmptyBudgetSpan()"
					class="form-control"
					id="newBudget"
					placeholder="Budget"
				>
			</div>

			<div class="col-md-2 form-group" style="padding:3px">
				<label for="effectiveStartDate">Effective Start Date</label>
				<b-form-datepicker
					:id="'effectiveStartDate'+arrIndex"
					placeholder="MM/DD/YYYY"
					:name="'startDate'+arrIndex"
					class="date_wrapper padding-custom"
					v-model="singleBudget.start_date"
					menu-class="w-100"
					size="sm"
					:date-format-options="{day: '2-digit',  month: '2-digit',  year: 'numeric' }"
					calendar-width="200%"
					:hide-header="true"
					:today-button="false"
					:min="currDate"
					:max="this.maxStartDAte"
					v-bind:disabled="hide"
					v-on:keydown="dontAllowManualDateEditing"
					@shown="setMinMaxStartDate();hideEmptyBudgetSpan();"
					@input="startDateValidation(true)"
					locale="en"
					v-bind:class="hide ? 'date-disabled' :''"
				>
			</b-form-datepicker>
				<!-- <input
					type="date"
					v-model="singleBudget.start_date"
					:min="this.currDate"
					:max="this.maxStartDAte"
					v-bind:disabled="hide"
					v-on:keydown="dontAllowManualDateEditing"
					v-on:click="setMinMaxStartDate();hideEmptyBudgetSpan();"
					@change="startDateValidation(true)"
					class="form-control padding-custom"
					id="effectiveStartDate"
				> -->
				<!-- <span v-if="InvalidDateSpan" style="color:red;font-size:13px;padding:5px"> Invalid Date Range</span> -->
			</div>

			<div class="col-md-2 form-group" style="padding:3px">
				<label for="effectiveEndDate">Effective End Date</label>
				<b-form-datepicker
					:id="'effectiveEndDate'+arrIndex"
					:name="'endDate'+arrIndex"
					placeholder="MM/DD/YYYY"
					class="date_wrapper padding-custom"
					v-model="singleBudget.end_date"
					menu-class="w-100"
					size="sm"
					:date-format-options="{day: '2-digit',  month: '2-digit',  year: 'numeric' }"
					calendar-width="200%"
					:hide-header="true"
					:today-button="false"
					:min="minEndDate"
					:max="maxEndDate"
					v-bind:disabled="hide || singleBudget.start_date == '' "
					v-on:keydown="dontAllowManualDateEditing"
					@input="overlappingDate()"
					locale="en"
					:class="(hide || singleBudget.start_date == '')?'date-disabled':''"
				></b-form-datepicker>
				<!-- <input
				type="date"
				v-model="singleBudget.end_date"
				:max="this.maxEndDate"
				:min="this.minEndDate"
				v-on:keydown="dontAllowManualDateEditing"
				@change="overlappingDate()"
				v-bind:disabled="hide || this.singleBudget.start_date == ''"
				id="effectiveEndDate"
				class="form-control padding-custom"
				> -->
			</div>
			<div class="col-md-2 form-group" v-if="singleBudget.id" style="padding:3px">
				<label for="fallbackBudget">FallBack Budget</label>
				<input
					type="text"
					v-model="fallbackBudget"
					disabled="true"
					id="fallbackBudget"
					class="form-control"
				>
			</div>
			<div v-else class="col-md-2 form-group" style="padding:3px"></div>
			<div v-if="singleBudget.id" class="col-md-1 form-group" style="padding:3px">
				<label for="status">Status</label>
				<input
					type="text"
					style="padding:6px"
					v-model="singleBudget.status"
					disabled="true"
					class="form-control"
				>
			</div>
			<div v-else class="col-md-1 form-group" style="padding:3px"></div>
			<div v-show="showSaveSpinner" class="spinner-border" style="margin:35px;display:block;"></div>
			<div v-show="!showSaveSpinner" class="col-md-2" style="padding:1px;margin-top:27px;">
				<div v-if="campaignId != 'null' &&  campaignId != 'NullWithPrefilledVendorBrand'">
					<div style="margin-left:5px;padding:2px;" v-if="!showDelete">
						<button
							style="color:white"
							id="save"
							class="btn btn-primary"
							v-if="this.singleBudget.end_date != '' && this.singleBudget.start_date != '' && this.singleBudget.budget != '' && this.showSave == true"
							v-on:click="save"
						>Save</button>
						<button
							style="color:white"
							id="edit"
							class="btn btn-primary"
							v-on:click="edit"
							v-if="this.showEdit && this.allowEdit"
						>Edit</button>
						<button
							style="color:white"
							id="cancel"
							class="btn btn-primary"
							v-if=" (this.showSaveCancel== true) || this.showSave == true && (this.singleBudget.end_date == '' || this.singleBudget.start_date == '' || this.singleBudget.budget == '') && this.showCancel == true "
							v-on:click="cancel"
						>Cancel</button>
						<button
							v-if="(this.showAdd && this.singleBudget.end_date != ''  && this.singleBudget.start_date != '' && this.singleBudget.budget != '' && this.arrIndex == (this.budgetItems).length-1) || (this.budgetItems.length == 1 && this.showAdd && this.singleBudget.id) "
							style="color:white"
							class="btn btn-primary"
							id="add"
							v-on:click="addToArray"
						>Add</button>
					</div>
					<div style="margin-left:5px;padding:2px;" v-else>
						<button
							style="color:white;background-color:red"
							id="delete"
							class="btn btn-primary"
							v-on:click="deleteFromArray"
							v-if="this.allowEdit"
						>Delete</button>
					</div>
				</div>
			</div>
		</div>
		<DeletePopUp
			v-if="isOpenDeleteModal"
			@deleteData="deleteData"
			@hideDeleteModal="hideDeleteModal"
		/>
	</div>
</template>
<script>
	import DeletePopUp from "../delete/DeletePopUp.vue";
	var moment = require("moment");
	var numeral = require("numeral");
	const formatCurrency = require("format-currency");
	export default {
		name: "ModifyEdit",

		components: {
			DeletePopUp
		},
		props: [
			"arrIndex",
			"budgetItems",
			"singleBudget",
			"campaignId",
			"showAdd",
			"startDateArray",
			"endDateArray",
			"allowEdit",
			"showExpired"
		],
		data() {
			return {
				//InvalidDateSpan: false,
				fallbackBudget: "0",
				showSave: true,
				showEdit: false,
				showCancel: true,
				showSaveCancel: false,
				showSaveSpinner: false,
				showDelete: false,
				flag: true,
				hide: false,
				currentDate: "",
				currDate: "",
				maxEndDate: "",
				minEndDate: "",
				maxStartDAte: "",
				isOpenDeleteModal: false,
				itemToDelId: {},
				copy: {
					id: "",
					budget: "",
					fallback_budget: "0",
					start_date: "",
					end_date: ""
				},
				renderComponent:true
			};
		},
		methods: {
			forceRerender () {
				this.renderComponent = false;
				this.$nextTick (() => {
				 this.renderComponent = true;
				});
			},
			hideEmptyBudgetSpan() {
				this.$emit("hideEmptyBudgetSpan");
			},
			validKey(event) {
				var x = event.keyCode;
				if (
					!(
						(48 <= x && x <= 57) ||
						x == 8 ||
						x == 39 ||
						x == 37 ||
						x == 190 || (x>=96 && x<= 105) || x == 110
					)
				) {
					event.preventDefault();
					this.flag = false;
				}
			},
			dontAllowManualDateEditing(event) {
				var x = event.keyCode;
				if (x) {
					event.preventDefault();
				}
			},
			deleteData() {
				//this.$refs.modifyEditRef.deleteDataFromModal();
				this.hideDeleteModal();
				this.showSaveSpinner = true;
				let vm = this;
				var onlyBudgetUpdate = true;
				let callback = () => {
					vm.showSaveSpinner = false;
				};
				this.$store
					.dispatch("campaign/deleteItemFromBudgetItem", this.itemToDelId)
					.then(response => {
						vm.$emit(
							"getCampaignGroupById",
							onlyBudgetUpdate,
							callback
						);
						this.$emit("showToggleButton", false);
					});
			},
			hideDeleteModal() {
				this.isOpenDeleteModal = false;
			},
			addToArray() {
				this.$emit("hideShowAdd");
				this.$emit("add");
			},
			cancel() {
				this.showCancel = false;
				this.showSaveCancel = false;
				if (!(this.budgetItems.length == 0 && !this.singleBudget.id)) {
					this.$emit("unhideShowAdd");
				}
				if (this.singleBudget.id) {
					this.showEdit = true;
					this.showSave = false;
					this.$emit("unhideShowAdd");
					this.hide = true;
					this.singleBudget.id = this.copy.id;
					this.singleBudget.budget = this.copy.budget;
					this.singleBudget.start_date = this.copy.start_date;
					this.singleBudget.end_date = this.copy.end_date;
					this.$emit("increementArrayDates", this.arrIndex);
					this.$emit("alterEdit");
				} else if (this.arrIndex == 0) {
					this.showCancel = true;
					this.$emit("delete", this.arrIndex);
				} else {
					this.$emit("delete", this.arrIndex);
				}
				this.forceRerender()
			},
			deleteFromArray() {
				var Item = { id: this.singleBudget.id };
				this.itemToDelId = Item;
				this.isOpenDeleteModal = true;
			},

			save() {
				this.$emit("unhideShowAdd");
				//this.$emit("showInternalLoaderFn");

				this.showSaveSpinner = true;
				this.computeStatus();
				// this.$emit("increementCount");
				var number = numeral(this.singleBudget.budget);

				if (this.singleBudget.id) {
					this.$emit("alterEdit");
					var Item = {
						requestType: "add",
						budget: {
							id: this.singleBudget.id,
							campaign_group_id: this.campaignId,
							budget: number.value(),
							fallback_budget: "0",
							start_date: this.singleBudget.start_date,
							end_date: this.singleBudget.end_date,
							start_date_utc:moment(this.singleBudget.start_date).utc().subtract(moment().parseZone().utcOffset(), 'minutes').utc().valueOf(),
							end_date_utc:moment(this.singleBudget.end_date).utc().subtract(moment().parseZone().utcOffset(), 'minutes').utc().valueOf(),
						}
					};
				} else {
					var Item = {
						requestType: "add",
						id: this.campaignId,
						budget: {
							budget: number.value(),
							fallback_budget: 0,
							start_date: this.singleBudget.start_date,
							end_date: this.singleBudget.end_date,
							start_date_utc: moment(this.singleBudget.start_date).utc().subtract(moment().parseZone().utcOffset(), 'minutes').utc().valueOf(),
							end_date_utc: moment(this.singleBudget.end_date).utc().subtract(moment().parseZone().utcOffset(), 'minutes').utc().valueOf(),
						}
					};



				}
				const vm = this;

				console.log(Item);
				this.$store
					.dispatch("campaign/addProductsToCampaign", Item)
					.then(response => {
						var onlyBudgetUpdate = true;
						let callback = () => {
							vm.showSaveSpinner = false;
						};
						vm.$emit(
							"getCampaignGroupById",
							onlyBudgetUpdate,
							callback
						);
						vm.showSave = false;
						vm.showEdit = true;
						vm.hide = true;
						vm.showSaveCancel = false;
					});
			},
			edit() {
				this.hide = false;
				this.showSave = true;
				this.showEdit = false;
				//this.showAdd = false;
				this.showSaveCancel = true;
				this.$emit("hideShowAdd");
				this.$emit("alterEdit");
				this.$emit("decreementArrayDates", this.arrIndex);
				this.startDateValidation();
				console.log(this.singleBudget.id);
			},
			setMaxDate(date) {
				if (moment().date() < 14) {
					var validDate = moment([
						moment(date).year(),
						moment(date).month()
					]);
					//
					return validDate.endOf("month").format("YYYY-MM-DD");
				} else {
					var validDate = moment([
						moment(date).year(),
						moment(date).month()
					]);
					validDate = validDate.add("months", 2);
					return validDate.subtract("days", 1).format("YYYY-MM-DD");
				}
			},
			startDateValidation(resetEndDate) {
				if (resetEndDate) {
					this.singleBudget.end_date = this.singleBudget.start_date;
				}
				this.minEndDate = (moment().isAfter(moment(this.singleBudget.start_date))?moment().format("YYYY-MM-DD"):moment(this.singleBudget.start_date).format("YYYY-MM-DD"))
				this.maxEndDate = this.setMaxDate(moment().format("YYYY-MM-DD"));
				if (!this.overlappingDate()) {
					//this.showEdit = true;
				}
			},
			setMinMaxStartDate() {
				//this.InvalidDateSpan = false;
				// this.currDate = moment().isAfter(
				// 	moment(this.singleBudget.start_date)
				// )
				// 	? moment(this.singleBudget.start_date).format("YYYY-MM-DD")
				// 	: moment().format("YYYY-MM-DD");
				this.currDate = moment().add("days", 1).format("YYYY-MM-DD");
				this.maxStartDAte = this.setMaxDate(moment().format("YYYY-MM-DD"));
			},
			overlappingDate() {
				for (var i = 0; i < this.startDateArray.length; i++) {
					if (
						(new Date(this.singleBudget.start_date) >=
							new Date(this.startDateArray[i]) &&
							new Date(this.singleBudget.start_date) <=
								new Date(this.endDateArray[i])) ||
						(new Date(this.singleBudget.start_date) >=
							new Date(this.startDateArray[i]) &&
							new Date(this.singleBudget.end_date) <=
								new Date(this.endDateArray[i])) ||
						(new Date(this.singleBudget.end_date) >=
							new Date(this.startDateArray[i]) &&
							new Date(this.singleBudget.end_date) <=
								new Date(this.endDateArray[i])) ||
						(new Date(this.singleBudget.start_date) <=
							new Date(this.startDateArray[i]) &&
							new Date(this.singleBudget.end_date) >=
								new Date(this.endDateArray[i]))
					) {
						//this.InvalidDateSpan = true;
						if (this.singleBudget.id) {
							this.singleBudget.start_date = this.copy.start_date;
							this.singleBudget.end_date = this.copy.end_date;
						} else {
							this.currDate = "";
							this.maxStartDAte = "";
							this.singleBudget.start_date = "";
							this.singleBudget.end_date = "";
						}
						alert("Invalid Date Selection");
						//setTimeout(() => this.InvalidDateSpan=false, 800);
					}
				}
				this.forceRerender()
			},
			computeStatus() {
				if (this.singleBudget.id) {
					if (this.singleBudget.status == "Expired") {
						this.showDelete = true;
						//this.$emit("showToggleButton", true);
					}
				}
			},
			validations() {
				if (this.singleBudget.id) {
					this.showSave = false;
					this.$emit("unhideShowAdd");
					this.showEdit = true;
					this.showCancel = true;
					this.hide = true;
					this.formatNum(this.singleBudget.budget);
					this.copy.id = this.singleBudget.id;
					this.copy.budget = this.singleBudget.budget;
					this.copy.start_date = this.singleBudget.start_date;
					this.copy.end_date = this.singleBudget.end_date;
				}
			},
			formatNum(num) {
				if (this.flag == true) {
					var number = numeral(num);
					this.singleBudget.budget = formatCurrency(number.value());
					// var num = formatCurrency(number.value());
					// this.singleBudget.budget = num.slice(0, num.length - 3);
				}
			}
		},
		mounted() {
			this.validations();
			this.computeStatus();
		},
		watch: {
			// singleBudget: function() {
			// 	this.formatNum(this.singleBudget.budget);
			// }
		}
	};
</script>
<style lang="scss">
input[type="date"] {
	-moz-appearance: textfield;
}
input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.padding-custom{
	padding-left: 5px !important;
	padding-right: 2px !important;
}
</style>
